import { memo } from 'react';
import classNames from 'classnames';

import type { Config } from 'Config/types';

import { I13nAnchor } from 'Components/I13n';

import { commonLinkStyle } from 'Styles/sharedStyle';

type Props = Exclude<Config['loginPageExtraInfo'], null>;

const ExtraInfo = (props: Props) => {
  const { i13nMessage, introText, link, title } = props;

  return (
    <I13nAnchor
      className={classNames(
        commonLinkStyle,
        'My(40px) C($c-ds-text-primary-overlay) Ta(c) Whs(pw) Typs(body-1-link) Td(u) Td(n):h'
      )}
      i13nModel={{ message: i13nMessage }}
      href={link}
      target="_blank"
    >
      {introText}
      <p className="D(b) M(0)">{title}</p>
    </I13nAnchor>
  );
};

export default memo(ExtraInfo);
